import { getArtistPerson } from '../getArtistPerson/getArtistPerson';
import type { components } from '#lib/api/generated/schema.js';
import { HENI_ORGANIZATION_REF } from '#lib/features/seo/constants/heni-organization.js';
import { omitEmpty } from '$global/utils/omitEmpty/omitEmpty';

type ExhibitionDetail = NonNullable<components['schemas']['ExhibitionDetail']>;

// Timezone-less timestamps: a bare date stops Google guessing a zone.
const toDate = (timestamp: string | null) => timestamp?.slice(0, 10);

export const getExhibitionJsonLd = (
	exhibition: ExhibitionDetail | null | undefined,
	url: string
) => {
	if (!exhibition?.title || !exhibition.start_date) {
		return null;
	}

	const location = exhibition.short_location_description?.trim();

	return omitEmpty({
		'@context': 'https://schema.org',
		'@type': 'ExhibitionEvent',
		'@id': `${url}#event`,
		url,
		name: exhibition.title,
		startDate: toDate(exhibition.start_date),
		endDate: toDate(exhibition.end_date),
		eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
		eventStatus: 'https://schema.org/EventScheduled',
		// Free text: the CMS has no structured address.
		location: location ? { '@type': 'Place', name: location } : undefined,
		organizer: HENI_ORGANIZATION_REF,
		performer: (exhibition.artists ?? [])
			.map((junction) => getArtistPerson(junction.Artists_id))
			.filter(Boolean),
	});
};
